import { createApi } from "@reduxjs/toolkit/query/react";
import { RESTAURANT_REQUEST, TagId, TagType } from "../../configs";
import {
  RestaurantRequest,
  PaginatedResponse,
  SearchByDisplayName,
  HttpMethod,
} from "../../types";
import { createBaseQuery } from "../helpers/baseQueryHelper";

const restaurantRequestApi = createApi({
  reducerPath: RESTAURANT_REQUEST.reducerPath,
  baseQuery: createBaseQuery(RESTAURANT_REQUEST.baseUrl),
  tagTypes: RESTAURANT_REQUEST.tagTypes,
  endpoints(builder) {
    return {
      fetchRestaurantRequests: builder.query<
        PaginatedResponse<RestaurantRequest>,
        SearchByDisplayName
      >({
        query: (searchQuery) => {
          return {
            url: "/",
            method: HttpMethod.GET,
            params: searchQuery,
          };
        },
        providesTags: () => [
          { type: TagType.RestaurantRequest, id: TagId.LIST },
        ],
      }),

      deleteRestaurantRequest: builder.mutation<void, string>({
        query: (restaurantRequestId) => ({
          url: `/${restaurantRequestId}`,
          method: HttpMethod.DELETE,
        }),
        invalidatesTags: () => [
          { type: TagType.RestaurantRequest, id: TagId.LIST },
        ],
      }),
    };
  },
});

export const {
  useFetchRestaurantRequestsQuery,
  useDeleteRestaurantRequestMutation,
} = restaurantRequestApi;

export { restaurantRequestApi };
